import { render, staticRenderFns } from "./ScreensLogsList.vue?vue&type=template&id=af38d8a6&"
import script from "./ScreensLogsList.vue?vue&type=script&lang=js&"
export * from "./ScreensLogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports